const slugify = (value: string): string => {
  return value
    .replace(/\s+/, '-')
    .replace(/-{2,}/, '-')
    .replace(/[^a-z0-9\s-]/i, '')
    .toLowerCase()
}

export default slugify
